<template>
  <div class="commonDate">
    <ul>
      <li v-for="(item,index) in dateList" :key="index" :class="active==index?'dateActive':''" @click="selectType(item,index)">{{ item.name }}</li>
    </ul>
    <!--日期-->
    <el-date-picker v-if="dateType==='DAY'" v-model="day" :clearable="false" type="daterange" :picker-options="dayPickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handlerFilter"></el-date-picker>
    <!--月份-->
    <el-date-picker v-if="dateType==='MONTH'" v-model="month" :clearable="false" type="monthrange" :picker-options="monthPickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM" @change="handlerFilter"></el-date-picker>
    <!--季度-->
    <div v-else-if="dateType === 'QUARTER'" class="date-box">
      <!--ref="startQuarter",限制:limit="startLimit" :default-year="startYearTow" :default-value="startQuarter" -->
      <quarter key="start" :show-value="startQuarter" :limit="startLimit" @selectQuarter="selectStartQuarter" />
      <div style="display:inline-block;width:33px;text-align: center">
        至
      </div>
      <!-- ref="endQuarter" :limit="endLimit" :default-year="endYearTow" :default-value="endQuarter" -->
      <quarter key="end" :show-value="endQuarter" :limit="endLimit" @selectQuarter="selectEndQuarter" />
    </div>
    <!--年-->
    <div v-else-if="dateType === 'YEAR'" class="date-box">
      <el-date-picker v-model="startYear" :clearable="false" type="year" :picker-options="startYearOptions" placeholder="开始年份" class="date-box-start" value-format="yyyy" @change="handlerFilter" />
      <span style="display:inline-block;width:33px;text-align: center">至</span>
      <el-date-picker v-model="endYear" :clearable="false" type="year" :picker-options="endYearOptions" placeholder="结束年份" class="date-box-end" value-format="yyyy" @change="handlerFilter" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import quarter from '../quarter/quarter.vue';

export default {
  components: { quarter },
  data() {
    const that = this;
    return {
      dateList: [
        { id: 0, name: '日', dateType: 'DAY' },
        { id: 1, name: '月', dateType: 'MONTH' },
        { id: 2, name: '季', dateType: 'QUARTER' },
        { id: 3, name: '年', dateType: 'YEAR' }
      ],
      active: 0,
      day: [dayjs().subtract(8, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      month: [dayjs().subtract(36, 'month').format('YYYY-MM'), dayjs().format('YYYY-MM')],
      year: [],
      startYear: dayjs(new Date()).subtract(3, 'year').format('YYYY'), // 开始年份
      endYear: dayjs(new Date()).format('YYYY'), // 结束年份
      dateType: 'DAY', // 时间类型（日：DAY,月：MONTH,季：QUARTER,年：YEAR）
      // 限制日期
      dayPickerOptions: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        }
      },
      // 限制月
      monthPickerOptions: {
        disabledDate(time) {
          const date = new Date();
          const year = date.getFullYear();
          let month = date.getMonth() + 2;
          if (month >= 1 && month <= 9) {
            month = `0${month}`;
          }
          const currentDate = year.toString() + month.toString();
          const timeYear = time.getFullYear();
          let timeMonth = time.getMonth() + 1;
          if (timeMonth >= 1 && timeMonth <= 9) {
            timeMonth = `0${timeMonth}`;
          }
          const timeDate = timeYear.toString() + timeMonth.toString();
          return currentDate <= timeDate;
        }
      },
      // 限制年
      startYearOptions: {
        disabledDate(time) {
          return (
            time.getFullYear() > that.endYear || time.getFullYear() > new Date().getFullYear());
        }
      },
      endYearOptions: {
        disabledDate(time) {
          return (
            time.getFullYear() < that.startYear || time.getFullYear() > new Date().getFullYear()
          );
        }
      },
      // 季度
      startQuarter: null, // 开始季度的季度
      endQuarter: null, // 结束季度的季度
      // startYearTow: null, // 开始季度的年
      // // startQuarter: null, // 开始季度的季度
      // startValue: null,
      // endYearTow: null, // 结束季度的年
      // // endQuarter: null, // 结束季度的季度
      // endValue: null,
      endLimit: null, // 结束季度的限制
    };
  },
  computed: {
    nowYear() {
      return dayjs().year() + 1000;
    },
    nowQuarter() {
      return this.makeQuarter();
    },
    startLimit() {
      return {
        upLimitYear: 0, upLimitQuarter: 0, downLimitYear: this.nowYear, downLimitQuarter: this.nowQuarter,
      };
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {
    this.setDefault();
    this.handlerFilter();
  },
  activated() {
    // this.setDefault();
    // this.handlerFilter();
  },
  methods: {
    selectType(item, index) {
      this.active = index;
      this.dateType = item.dateType;
      this.handlerFilter();
    },
    // 过滤处理
    handlerFilter() {
      const data = {
        beginTime: '',
        endTime: '',
        dateType: this.dateType
      };
      if (this.dateType == 'DAY') {
        data.beginTime = this.day[0];
        data.endTime = this.day[1];
      } else if (this.dateType === 'MONTH') {
        data.beginTime = this.month[0];
        data.endTime = this.month[1];
      } else if (this.dateType === 'QUARTER') {
        data.beginTime = this.startQuarter;
        data.endTime = this.endQuarter;
      } else if (this.dateType === 'YEAR') {
        data.beginTime = this.startYear;
        data.endTime = this.endYear;
      }
      console.log('ua1', data);
      window.sessionStorage.selectDate = window.JSON.stringify(data);
      this.$emit('selectDate', data);
    },
    // 选择开始的季度
    selectStartQuarter({ value, year, quarterValue }) {
      console.log('选择开始的季度', value, year, quarterValue);
      this.startQuarter = value;
      this.handlerFilter();
    },
    // 选择结束的季度
    selectEndQuarter({ value, year, quarterValue }) {
      console.log('选择结束的季度', value, year, quarterValue);
      this.endQuarter = value;
      this.handlerFilter();
    },
    // 设置默认值方法
    setDefault() {
      // 获取结束的年
      const endYearTow = dayjs().year();
      // 结束季度的季度
      const endQuarterTow = this.makeQuarter();
      // 获取开始的年
      const startYearTow = this.makeUpYear(endYearTow, endQuarterTow);
      const startQuarterTow = this.makeUpQuarter(endQuarterTow);
      this.startQuarter = `${startYearTow}-Q${startQuarterTow}`;
      this.endQuarter = `${endYearTow}-Q${endQuarterTow}`;
      // console.log('1-', this.endQuarter, this.startQuarter,);
      // this.countEndLimit(startYearTow, startQuarterTow, endYearTow, endQuarterTow);// -crm需要优化
    },
    // 根据月份计算季度
    makeQuarter(month = dayjs().month() + 1) {
      return Math.floor((month - 1) / 3) + 1;
    },
    // 根据年份选择上极限年份
    makeUpYear(year, quarterValue) {
      if (!(year && quarterValue)) { return null; }
      return quarterValue === 4 ? year - 1 : year - 2;
    },
    // 根据年份选择下极限年份
    makeDownYear(year, quarterValue) {
      if (!(year && quarterValue)) { return null; }
      return quarterValue === 1 ? year + 1 : year + 2;
    },
    // 根据季度选择上极限季度
    makeUpQuarter(quarterValue) {
      if (!quarterValue) { return null; }
      const value = Number(quarterValue);
      return (value + 1) === 5 ? 1 : (value + 1);
    },
    // 根据季度选择下极限季度
    makeDownQuarter(quarterValue) {
      if (!quarterValue) { return null; }
      const value = Number(quarterValue);
      return (value - 1) === 0 ? 4 : (value - 1);
    },
    // 计算结束季度限制
    countEndLimit(startYearTow, startQuarterTow, endYearTow, endQuarterTow) {
      console.log('日期限制', startYearTow, startQuarterTow, endYearTow, endQuarterTow);
      // 在之前限制的基础上加上今天的限制
      // const LimitYear = this.makeDownYear(startYearTow, startQuarterTow);
      // const LimitQuarter = this.makeDownQuarter(startQuarterTow);
      // console.log('1-', LimitYear, LimitQuarter);
      // let downLimitYear = null;
      // let downLimitQuarter = null;
      // if (LimitYear < this.nowYear) {
      //   downLimitYear = LimitYear;
      //   downLimitQuarter = LimitQuarter;
      //   console.log('1-');
      // } else if (LimitYear === this.nowYear) {
      //   downLimitYear = LimitYear;
      //   downLimitQuarter = LimitQuarter < this.nowQuarter ? LimitQuarter : this.nowQuarter;
      //   console.log('2-');
      // } else {
      //   downLimitYear = this.nowYear;
      //   downLimitQuarter = this.nowQuarter;
      //   console.log('3-');
      // }
      // if (this.noPickerOptions) {
      //   downLimitYear = this.nowYear;
      //   console.log('4-');
      // }
      this.endLimit = {
        upLimitYear: endYearTow,
        upLimitQuarter: endQuarterTow,
      };
      this.startLimit = {
        upLimitYear: startYearTow,
        upLimitQuarter: startQuarterTow,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.commonDate{
  display: inline-flex;
  ul{
    width: 203px;
    height: 38px;
    background-color: #ffffff;
    border-radius: 4px;
    border: solid 1px #d8dce5;
    text-align: center;
    margin-right: 20px;
    li{
      cursor: pointer;
      display: inline-block;
      width: 50px;
      height: 38px;
      line-height: 38px;
      border-right: 1px solid #d8dce5;
    }
    li:last-child{
      border-right:none!important;
    }
  }
  .date-box{
    display: inline-block;
    position: relative;
    span{
      font-size: 14px;
      color: #2d2f33;
    }
  }
  .dateActive{
    color: #ffffff!important;
  }
}
</style>
